<template>
    <div class="timer -mx-2 -mt-2  md:-mx-0 md:-mt-0 bg-red-light rounded-br-2xl rounded-bl-2xl font-open-sans">
        <div class="flex  p-2 sm:p-4">
            <div class="w-7/12 flex items-start">
                <span class="icon rounded-full bg-white p-1 mt-1">
                    <svg xmlns="http://www.w3.org/2000/svg" class="text-red-light"  width="24px" height="24px" viewBox="0 0 24 24">
                        <path fill="currentColor" d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,20a9,9,0,1,1,9-9A9,9,0,0,1,12,21Z" />
                        <rect width="2" height="7" x="11" y="6" fill="currentColor" rx="1">
                            <animateTransform attributeName="transform" dur="36s" repeatCount="indefinite" type="rotate" values="0 12 12;360 12 12" />
                        </rect>
                        <rect width="2" height="9" x="11" y="11" fill="currentColor" rx="1">
                            <animateTransform attributeName="transform" dur="10s" repeatCount="indefinite" type="rotate" values="0 12 12;360 12 12" />
                        </rect>
                    </svg>
                </span>
                <h3 class="font-bold text-sm px-1">OFERTA POR TEMPO LIMITADO</h3>
            </div>
            <div class="w-5/12 -mt-[3px]">
                <div class="flex justify-between items-center font-open-sans">
                    <span 
                        class="number text-xl font-extrabold pl-[0px]"
                        :style="{ animationDuration: durationInSeconds + 's' }">
                        {{ formatNumber(days) }}
                    </span>
                    <span class="text-white font-semibold pt-1 mt-1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="5" height="11" viewBox="0 0 3 9" fill="none">
                            <path d="M0.0625 6.86621C0.0625 6.38314 0.203776 6.04362 0.486328 5.84766C0.773438 5.65169 1.11751 5.55371 1.51855 5.55371C1.89681 5.55371 2.22493 5.65169 2.50293 5.84766C2.78092 6.04362 2.91992 6.38314 2.91992 6.86621C2.91992 7.3265 2.78092 7.65918 2.50293 7.86426C2.22493 8.06934 1.89681 8.17188 1.51855 8.17188C1.11751 8.17188 0.773438 8.06934 0.486328 7.86426C0.203776 7.65918 0.0625 7.3265 0.0625 6.86621ZM0.0625 1.46582C0.0625 0.987305 0.203776 0.650065 0.486328 0.454102C0.773438 0.258138 1.11751 0.160156 1.51855 0.160156C1.89681 0.160156 2.22493 0.258138 2.50293 0.454102C2.78092 0.650065 2.91992 0.987305 2.91992 1.46582C2.91992 1.93522 2.78092 2.27246 2.50293 2.47754C2.22493 2.67806 1.89681 2.77832 1.51855 2.77832C1.11751 2.77832 0.773438 2.67806 0.486328 2.47754C0.203776 2.27246 0.0625 1.93522 0.0625 1.46582Z" fill="white"/>
                        </svg>
                    </span>
                    <span 
                        class="number text-xl font-extrabold"
                        :style="{ animationDuration: durationInSeconds + 's' }">
                        {{ formatNumber(hours) }}
                    </span>
                    <span class="text-white font-semibold pt-1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="5" height="11" viewBox="0 0 3 9" fill="none">
                            <path d="M0.0625 6.86621C0.0625 6.38314 0.203776 6.04362 0.486328 5.84766C0.773438 5.65169 1.11751 5.55371 1.51855 5.55371C1.89681 5.55371 2.22493 5.65169 2.50293 5.84766C2.78092 6.04362 2.91992 6.38314 2.91992 6.86621C2.91992 7.3265 2.78092 7.65918 2.50293 7.86426C2.22493 8.06934 1.89681 8.17188 1.51855 8.17188C1.11751 8.17188 0.773438 8.06934 0.486328 7.86426C0.203776 7.65918 0.0625 7.3265 0.0625 6.86621ZM0.0625 1.46582C0.0625 0.987305 0.203776 0.650065 0.486328 0.454102C0.773438 0.258138 1.11751 0.160156 1.51855 0.160156C1.89681 0.160156 2.22493 0.258138 2.50293 0.454102C2.78092 0.650065 2.91992 0.987305 2.91992 1.46582C2.91992 1.93522 2.78092 2.27246 2.50293 2.47754C2.22493 2.67806 1.89681 2.77832 1.51855 2.77832C1.11751 2.77832 0.773438 2.67806 0.486328 2.47754C0.203776 2.27246 0.0625 1.93522 0.0625 1.46582Z" fill="white"/>
                        </svg>
                    </span>
                    <span 
                        class="number text-xl font-extrabold"
                        :style="{ animationDuration: durationInSeconds + 's' }">
                        {{ formatNumber(minutes) }}
                    </span>
                    <span class="text-white font-semibold pt-1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="5" height="11" viewBox="0 0 3 9" fill="none">
                            <path d="M0.0625 6.86621C0.0625 6.38314 0.203776 6.04362 0.486328 5.84766C0.773438 5.65169 1.11751 5.55371 1.51855 5.55371C1.89681 5.55371 2.22493 5.65169 2.50293 5.84766C2.78092 6.04362 2.91992 6.38314 2.91992 6.86621C2.91992 7.3265 2.78092 7.65918 2.50293 7.86426C2.22493 8.06934 1.89681 8.17188 1.51855 8.17188C1.11751 8.17188 0.773438 8.06934 0.486328 7.86426C0.203776 7.65918 0.0625 7.3265 0.0625 6.86621ZM0.0625 1.46582C0.0625 0.987305 0.203776 0.650065 0.486328 0.454102C0.773438 0.258138 1.11751 0.160156 1.51855 0.160156C1.89681 0.160156 2.22493 0.258138 2.50293 0.454102C2.78092 0.650065 2.91992 0.987305 2.91992 1.46582C2.91992 1.93522 2.78092 2.27246 2.50293 2.47754C2.22493 2.67806 1.89681 2.77832 1.51855 2.77832C1.11751 2.77832 0.773438 2.67806 0.486328 2.47754C0.203776 2.27246 0.0625 1.93522 0.0625 1.46582Z" fill="white"/>
                        </svg>
                    </span>
                    <span 
                        class="number text-xl font-extrabold pr-[0px]" 
                        :style="{ animationDuration: durationInSeconds + 's' }">
                        {{ formatNumber(seconds) }}
                    </span>
                </div>
                <div class="flex text-center font-light text-[11px] justify-around">
                    <div class="">DIAS</div>
                    <div class="">HOR</div>
                    <div class="">MIN</div>
                    <div class="">SEG</div>
                </div>
            </div>
        </div>        
    </div>
</template>
  
<script lang="ts">
import { ref, computed, onMounted, onUnmounted } from 'vue';

export default {
    setup() {
        const targetDate = new Date();
        targetDate.setDate(targetDate.getDate() + 0); // Define o prazo de  2 dias a partir de hoje
        targetDate.setHours(23, 59, 59, 999); // Define o horário de término

        const days = ref(Math.floor((targetDate - new Date()) / (1000 * 60 * 60 * 24)));
        const hours = ref(Math.floor((targetDate - new Date()) % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)));
        const minutes = ref(Math.floor((targetDate - new Date()) % (1000 * 60 * 60) / (1000 * 60)));
        const seconds = ref(Math.floor((targetDate - new Date()) % (1000 * 60) / 1000));
        const durationInSeconds = ref(days.value * 86400 + hours.value * 3600 + minutes.value * 60 + seconds.value);

        let intervalId: number | null = null;

        const prevValues = {
            days: ref(days.value),
            hours: ref(hours.value),
            minutes: ref(minutes.value),
        };


        const formatNumber = (num: number) => {
            return num.toString().padStart(2, '0');
        };

        const updateTime = () => {
            const now = new Date();
            const remaining = (targetDate.getTime() - now.getTime()) as number;

            if (remaining > 0) {
                days.value = Math.floor(remaining / (1000 * 60 * 60 * 24));
                hours.value = Math.floor((remaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                minutes.value = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
                seconds.value = Math.floor((remaining % (1000 * 60)) / 1000);
                durationInSeconds.value = days.value * 86400 + hours.value * 3600 + minutes.value * 60 + seconds.value;
            } else {
                clearInterval(intervalId);
                days.value = hours.value = minutes.value = seconds.value = 0;
            }
        };

        onMounted(() => {
            intervalId = window.setInterval(updateTime, 1000);
        });

        onUnmounted(() => {
            if (intervalId) {
                clearInterval(intervalId);
            }
        });

        return { days, hours, minutes, seconds, durationInSeconds, formatNumber };
    },
};
</script>
  
<style scoped>
.timer {
    font-size: 2em;
}

.number {
    display: inline-block;
    transition: all 0.5s ease;
}

@keyframes fallDown {
   0% {
    opacity:  1;
    transform: translateY(0);
  }
   100% {
    opacity:  0;
    transform: translateY(100%);
  }
}

.number {
    animation-name: fallDown;
    animation-timing-function: linear;
    animation-fill-mode: forwards;
}</style>